import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getCommentCount } from '../../../../../services/api';
import { rel } from '../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';

class Caption extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        joinNum: 0,
        count: 0,
    };

    async componentDidMount() {
        const { commentUrl } = this.props.content;

        try {
            const data = await getCommentCount(commentUrl);

            this.setState({
                joinNum: data.join_count,
                count: data.count,
            });
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { joinNum, count } = this.state;
        const { content } = this.props;
        const { noAd, title, pcUrl, newsTime, fhhAccountDetail, source, sourceUrl, commentUrl, skey } = content;
        const followUrl = `//gentie.ifeng.com/view.html?docUrl=${commentUrl}&docName=${encodeURIComponent(
            title,
        )}&skey=${skey}&pcUrl=${pcUrl}${noAd ? '&noAd' : ''}`;

        return (
            <div className={styles.caption}>
                <h1 className={styles.topic}>{title}</h1>
                <p>
                    <span className={styles.date}>{newsTime}</span>
                    {!fhhAccountDetail.weMediaName ? (
                        <span className={styles.source}>
                            {sourceUrl && sourceUrl !== '' ? (
                                <a href={sourceUrl} target="_blank" rel={rel}>
                                    {source}
                                </a>
                            ) : (
                                <span>{source}</span>
                            )}
                        </span>
                    ) : (
                        <span className={styles.source}>
                            <a
                                href={`//feng.ifeng.com/author/${fhhAccountDetail.eAccountId}`}
                                target="_blank"
                                rel={rel}>
                                {fhhAccountDetail.weMediaName}
                            </a>
                        </span>
                    )}
                </p>
                <div className={styles.comment_box}>
                    <h5 className={styles.comment}>
                        <a href={followUrl} target="_blank" rel={rel}>
                            <span className={styles.num}>{joinNum}</span>
                            <span className={styles.text}>人参与</span>
                        </a>
                        <a href={followUrl} target="_blank" rel={rel}>
                            <span className={styles.num}>{count}</span>
                            <span className={styles.text}>评论</span>
                        </a>
                    </h5>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Caption);
